import { useAllocationRuleGraphVersionBasisTableDataRetrieveSuspense } from "gen/endpoints/allocation-rule-graph/allocation-rule-graph";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import {
  OnChangeFn,
  RowSelectionState,
} from "shared/components/table/data/DataTableTypes";

export const AllocationBasisByRuleGraphVersionTable: React.FC<{
  rowSelection?: Record<string, boolean>;
  onRowSelectionChange?: OnChangeFn<RowSelectionState>;
  title: string;
  ruleGraphId: string;
  fundFamilyId: string;
  isFullScreen?: boolean;
}> = ({
  isFullScreen = false,
  rowSelection,
  onRowSelectionChange,
  title,
  ruleGraphId,
  fundFamilyId,
}) => {
  const { data: tableData } =
    useAllocationRuleGraphVersionBasisTableDataRetrieveSuspense(
      fundFamilyId,
      ruleGraphId,
    );

  return (
    <TableBox
      {...(isFullScreen
        ? {
            isFullHeight: true,
            isFullWidth: true,
          }
        : {})}
    >
      <TableBoxHeader>
        <TableBoxTitle>{title}</TableBoxTitle>
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable
          rowSelection={rowSelection}
          onRowSelectionChange={onRowSelectionChange}
          data={tableData}
        />
      </TableBoxBody>
    </TableBox>
  );
};
